function readRequiredEnv(name: 'VITE_API_URL' | 'VITE_ACCOUNT_URL'): string {
  const value = import.meta.env[name];

  if (!value) {
    throw new Error(`Missing required client environment variable: ${name}`);
  }

  return value;
}

function normalizeBaseUrl(baseUrl: URL): URL {
  const normalized = new URL(baseUrl.href);

  if (!normalized.pathname.endsWith('/')) {
    normalized.pathname = `${normalized.pathname}/`;
  }

  return normalized;
}

function buildHttpUrl(baseUrl: URL, pathname: string): URL {
  return new URL(pathname, normalizeBaseUrl(baseUrl));
}

function buildWebSocketUrl(baseUrl: URL, pathname: string): URL {
  const url = buildHttpUrl(baseUrl, pathname);
  url.protocol = baseUrl.protocol === 'https:' ? 'wss:' : 'ws:';
  return url;
}

class RuntimeUrls {
  public readonly apiUrl: URL;

  public readonly accountUrl: URL;

  constructor() {
    this.apiUrl = new URL(readRequiredEnv('VITE_API_URL'));
    this.accountUrl = new URL(readRequiredEnv('VITE_ACCOUNT_URL'));
  }

  public getGameCreationUrl(): URL {
    return buildHttpUrl(this.apiUrl, 'game/new');
  }

  public getGameSessionUrl(gameId: string): URL {
    return buildHttpUrl(this.apiUrl, `game/${encodeURIComponent(gameId)}/session`);
  }

  public getGameWebSocketUrl(gameId: string): URL {
    return buildWebSocketUrl(this.apiUrl, `game/${encodeURIComponent(gameId)}`);
  }

  public getAccountUrl(): string {
    return this.accountUrl.href;
  }
}

export const runtimeUrls = new RuntimeUrls();
